<template>
    <v-dialog
        :value="add_training.active"
        lazy
        max-width="636px"
        width="100%"
        @input="CLOSE_MODAL('add_training')"
        @keydown.esc="CLOSE_MODAL('add_training')"
    >
        <v-card class="study-card">
            <v-card-title>
                <v-layout justify-end>
                    <v-btn icon @click="CLOSE_MODAL('add_training')">
                        <v-icon color="#4A4A4A">mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text class="study-card--content mt-3">
                <v-form @submit.prevent>
                    <h2 class="study-card--title mb-4">
                        {{ $t("Назначить обучение") }}
                    </h2>
                    <v-flex md12 sm12 xs12
                            mb-4
                    >
                        <div class="grey-text mb-2">
                            {{ $t("Курс") }}
                        </div>
                        <v-select
                            v-model="new_training.testId"
                            :items="courses"
                            item-value="id"
                            item-text="name"
                            solo
                            append-icon=""
                            chips
                            hide-details
                            :no-data-text="$t('Не найдено подходящих записей')"
                            :label="$t('Выбрать из списка')"
                            class="study-card--select input"
                            :class="{ 'form-group--error': $v.new_training.testId.$error }"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-flex md12 sm12 xs12
                            mb-4
                    >
                        <div class="grey-text mb-2">
                            {{ $t("Организация") }}
                        </div>

                        <AutocompleteWithSelectAll
                            :model="new_training.companiesIds"
                            :organizations="organizations"
                            @update:model="new_training.companiesIds = $event"
                        />
                    </v-flex>
                    <v-flex md6 sm6 xs12>
                        <div class="grey-text mb-2">
                            {{ $t("Период обучения") }}
                        </div>
                        <v-select
                            v-model="new_training.appointmentDate"
                            append-icon=""
                            solo
                            :items="[
                                { label: `15 ${$t('дней')}`, value: 15 },
                                { label: `30 ${$t('дней')}`, value: 30 },
                                { label: `45 ${$t('дней')}`, value: 45 }
                            ]"
                            hide-details
                            item-value="value"
                            item-text="label"
                            class="study-card--select input"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-select>
                    </v-flex>
                    <v-card-actions class="mt-5">
                        <v-layout align-center wrap>
                            <buttonRed
                                :class="{ 'flex xs12': $vuetify.breakpoint.xs }"
                                @click.native="send_new_training()"
                            >
                                {{ $t("Назначить курс") }}
                            </buttonRed>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {required} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import AutocompleteWithSelectAll from '@/components/ui/autocompletewithselectall/AutocompleteWithSelectAll.vue';

export default {
  components: {
    AutocompleteWithSelectAll,
    buttonRed,
  },
  mixins: [validationMixin],
  validations() {
    return {
      new_training: {
        testId: {
          required,
        },
        companiesIds: {
          required,
        },
        appointmentDate: {
          required,
        },
      },
    };
  },
  data() {
    return {
      courses      : [],
      organizations: [],
      new_training : {
        testId         : '',
        companiesIds   : [],
        appointmentDate: 45,
      },
    };
  },

  computed: {
    ...mapGetters('learning_management/modals', ['add_training']),

  },

  async mounted() {
    const allOrganizationsCourses = await this.get_all_organizations_courses();

    this.courses = allOrganizationsCourses.courses;
    this.organizations = allOrganizationsCourses.organizations;
  },
  methods: {
    ...mapMutations('learning_management/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
    ...mapActions('learning_management/modals', [
      'create_assigned_test',
      'get_all_organizations_courses',
    ]),


    async send_new_training() {
      this.$v.$touch();

      if (!this.$v.$error) {
        try {
          await this.create_assigned_test(this.new_training);

          this.CLOSE_MODAL('add_training');
        } catch (error) {
          console.error(error);
        }
      }
    },
  },
};
</script>

<style lang="less">
@import url("../../../../less/variables");

.study-card {
  padding: 0 0 60px;
  color: #4a4a4a;

  &--title {
    font-size: 48px;
    line-height: 58px;
    font-family: @main-font;
    color: #4a4a4a;
    font-weight: 400;
  }

  &--content {
    padding: 0 60px;
    max-height: 60vh;
    overflow: auto;
  }
}


</style>
